import { put,getContext} from "redux-saga/effects";
import importer from "common/importer";
const { getVendorRedeemPaused } = importer("GraphQL/Queries");
const PublicContentActions = importer('Stores/PublicContent/Actions')

export default function* main() {
  try {
    yield put(PublicContentActions.getVendorRedeemPausedLoading());
    const apolloClient = yield getContext('client')
    const query = getVendorRedeemPaused;
    const { data, error } = yield apolloClient.query({
      query,
      fetchPolicy: "network-only",
      variables: {},
    });
    if (error) {
      throw error;
    }
    const res = data?.salesforce_bll_redemption_vendor__c;
    
    yield put(
      PublicContentActions.getVendorRedeemPausedSuccess(res)
    );
  } catch (error) {
    yield put(PublicContentActions.getVendorRedeemPausedFailure(error));
  }
}
